export interface PublishingPosterbookingPanelProps {
  // add props here
  onClose: VoidFunction;
}

export interface PosterBookingAJAXAuthResponse {
  isAuthenticated: boolean;
}

export interface PosterBookingPlaylist {
  id: number;
  name: string;
}

export enum PosterBookingPanelProgressState {
  STEP_CONNECT = 'STEP_CONNECT',
  STEP_AUTH = 'STEP_AUTH',
  STEP_LOADING = 'STEP_LOADING',
  STEP_PUBLISH = 'STEP_PUBLISH',
  STEP_UNLINKED = 'STEP_UNLINKED',
}

export enum PosterBookingOAuthEvent {
  SUCCESS = 'posterbooking:auth-success',
  ERROR = 'posterbooking:auth-error',
}

export const posterBookingBroadcastChannelName = 'posterbooking-broadcast-channel';
